import { useState } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

const projects = [
  {
    id: 1,
    name: 'Blue Ocean Access Fund',
    category: 'Investment Fund',
    location: 'New York, NY',
    description: 'A sleek, sophisticated website for a growth equity investment fund — designed to establish credibility and connect with exceptional entrepreneurs seeking capital partnerships.',
    image: 'https://static.readdy.ai/image/25203592582f416a5bf3ad1425ed1a29/19e1725a490fda1fe0ddae7ff65c9527.png',
    url: 'https://blueoceanaccessfund.com',
    tags: ['Website Design', 'Finance', 'Investment'],
    filter: 'finance'
  },
  {
    id: 2,
    name: 'Coffee Barn',
    category: 'Coffee Shop & Convenience',
    location: 'Merrick, NY',
    description: 'A vibrant, eye-catching website for Long Island\'s famous drive-thru coffee spot — built to showcase their specialty drinks and drive traffic to both locations.',
    image: 'https://static.readdy.ai/image/25203592582f416a5bf3ad1425ed1a29/2cacd8ef69ccf05498a2e198a57d78fe.png',
    url: 'https://coffeebarnli.com',
    tags: ['Website Design', 'Food & Beverage', 'Local Business'],
    filter: 'food-beverage'
  },
  {
    id: 3,
    name: 'Dugo Law',
    category: 'Legal Services',
    location: 'Sandy Hook, CT',
    description: 'A trustworthy, polished law firm website designed to establish credibility and convert visitors into clients.',
    image: 'https://static.readdy.ai/image/25203592582f416a5bf3ad1425ed1a29/fe0488dec077d8a1f555d7e15f082e7e.jpeg',
    url: 'https://dugolaw.com',
    tags: ['Website Design', 'Law Firm', 'Professional'],
    filter: 'law'
  },
  {
    id: 4,
    name: 'EF Carpentry',
    category: 'Home Improvement',
    location: 'Long Island, NY',
    description: 'A clean, professional website built to showcase craftsmanship and drive local leads for a Long Island carpentry business.',
    image: 'https://static.readdy.ai/image/25203592582f416a5bf3ad1425ed1a29/71f4c6a59ba8ffe6c1e798e08435e02f.jpeg',
    url: 'https://efcarpentryservice.com/',
    tags: ['Website Design', 'Local Business', 'Lead Generation'],
    filter: 'local-business'
  },
  {
    id: 5,
    name: 'Feren\'s Landscaping',
    category: 'Landscaping',
    location: 'Bellport, NY',
    description: 'A stunning, nature-inspired website for a premier Long Island landscaping company — designed to showcase their outdoor transformations and generate local leads.',
    image: 'https://static.readdy.ai/image/25203592582f416a5bf3ad1425ed1a29/cf15346dde6f7d5765d27190d7b7f256.png',
    url: 'https://ferenslandscaping.com',
    tags: ['Website Design', 'Landscaping', 'Local Business'],
    filter: 'local-business'
  },
  {
    id: 6,
    name: 'Glenn Wayne Bakery',
    category: 'Bakery',
    location: 'Bohemia, NY',
    description: 'A warm, inviting bakery website that brings the in-store experience online and drives foot traffic.',
    image: 'https://static.readdy.ai/image/25203592582f416a5bf3ad1425ed1a29/a13793ec178b837d99d341b8efb539ea.jpeg',
    url: 'https://www.GlennWayne.com',
    tags: ['Website Design', 'Food & Beverage', 'Local Business'],
    filter: 'food-beverage'
  },
  {
    id: 7,
    name: 'Grand Slam Stories',
    category: 'Baseball Card Subscription',
    location: 'USA',
    description: 'A dynamic, sports-driven e-commerce website for a baseball card and letter subscription service — built to capture the nostalgia of the game and convert passionate fans into loyal subscribers.',
    image: 'https://static.readdy.ai/image/25203592582f416a5bf3ad1425ed1a29/e0dcfea1cab915b8df45ccae46136315.png',
    url: 'https://grandslamstories.com',
    tags: ['Website Design', 'E-Commerce', 'Sports & Collectibles'],
    filter: 'ecommerce'
  },
  {
    id: 8,
    name: 'Jerry Sturiano',
    category: 'Musician',
    location: 'Long Island, NY',
    description: 'A bold, expressive personal site for a Long Island musician — built to capture his sound and connect with fans.',
    image: 'https://static.readdy.ai/image/25203592582f416a5bf3ad1425ed1a29/9931a596da4e7519495f5051fa47b4ee.jpeg',
    url: 'https://rome77.com',
    tags: ['Website Design', 'Personal Brand', 'Music'],
    filter: 'personal'
  },
  {
    id: 9,
    name: 'Media Leidy',
    category: 'Digital Marketing',
    location: 'New Jersey',
    description: 'A bold, conversion-focused website for a New Jersey digital marketer — built to showcase social media management, videography, and web design services for local businesses across NY and NJ.',
    image: 'https://static.readdy.ai/image/25203592582f416a5bf3ad1425ed1a29/aabe5bda03beb24693933fd77463a88c.png',
    url: 'https://medialeidy.com',
    tags: ['Website Design', 'Digital Marketing', 'Personal Brand'],
    filter: 'personal'
  },
  {
    id: 10,
    name: 'Mirror Mirror',
    category: 'Hair Salon',
    location: 'Merrick, NY',
    description: 'An elegant, boutique website for a Merrick hair salon — designed to reflect their artistry and premium experience while driving appointment bookings.',
    image: 'https://static.readdy.ai/image/25203592582f416a5bf3ad1425ed1a29/863eb16afd102d32a1747069d131e18c.png',
    url: 'https://mirrormirrormerrick.com',
    tags: ['Website Design', 'Beauty & Wellness', 'Local Business'],
    filter: 'local-business'
  },
  {
    id: 11,
    name: 'Reiken Construction Management',
    category: 'Construction Management',
    location: 'New York, NY',
    description: 'A bold, high-impact website for a NYC-based construction management firm — built to showcase their expertise in luxury retail displays, commercial buildouts, and government projects since 1995.',
    image: 'https://static.readdy.ai/image/25203592582f416a5bf3ad1425ed1a29/2347f1d6f3978684f6767226e79e8a29.png',
    url: 'https://reikenconstructionmanagement.com',
    tags: ['Website Design', 'Construction', 'NYC'],
    filter: 'local-business'
  },
  {
    id: 12,
    name: 'Sugar Bae Cafe',
    category: 'Dessert Shop',
    location: 'Hicksville, NY',
    description: 'A sweet, vibrant website for a late-night dessert cafe — designed to showcase their handcrafted bubble waffles, crepes, and milkshakes while driving foot traffic to their Hicksville location.',
    image: 'https://static.readdy.ai/image/25203592582f416a5bf3ad1425ed1a29/4267df2aa39060cac8818134667bb750.png',
    url: 'https://sugarbaecafe.com',
    tags: ['Website Design', 'Food & Beverage', 'Local Business'],
    filter: 'food-beverage'
  },
  {
    id: 13,
    name: 'The Bracelet Connection',
    category: 'Handmade Jewelry',
    location: 'Holbrook, NY',
    description: 'A beautiful, boutique website for a custom handmade bracelet business — designed to showcase their one-of-a-kind creations and bring the bracelet party experience to customers across Long Island.',
    image: 'https://static.readdy.ai/image/25203592582f416a5bf3ad1425ed1a29/c05960b855e16d8f131d5d7cd893c77a.png',
    url: 'https://thebraceletconnection.com',
    tags: ['Website Design', 'Handmade Jewelry', 'Local Business'],
    filter: 'ecommerce'
  }
];

const filters = [
  { label: 'All Projects', value: 'all' },
  { label: 'Law', value: 'law' },
  { label: 'Food & Beverage', value: 'food-beverage' },
  { label: 'Local Business', value: 'local-business' },
  { label: 'E-Commerce', value: 'ecommerce' },
  { label: 'Finance', value: 'finance' },
  { label: 'Personal Brand', value: 'personal' }
];

export default function PortfolioPage() {
  const [activeFilter, setActiveFilter] = useState('all');

  const filteredProjects = activeFilter === 'all' 
    ? projects 
    : projects.filter(p => p.filter === activeFilter);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <title>Portfolio | Website Design Work | Bellport Branding - Long Island</title>
      <meta name="description" content="Browse our portfolio of custom website designs for local businesses across Long Island, NY and beyond. Real results, real clients. Law firms, restaurants, retail, and more." />
      <meta name="keywords" content="website design portfolio Long Island, web design examples Nassau County, Suffolk County website portfolio, Long Island web designer work, custom website examples" />
      <link rel="canonical" href="https://www.bellportbranding.com/portfolio" />
      
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://www.bellportbranding.com/portfolio" />
      <meta property="og:title" content="Portfolio | Website Design Work | Bellport Branding" />
      <meta property="og:description" content="Browse our portfolio of custom website designs for local businesses across Long Island, NY and beyond." />
      <meta property="og:image" content="https://www.bellportbranding.com/og-image.jpg" />
      
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content="https://www.bellportbranding.com/portfolio" />
      <meta property="twitter:title" content="Portfolio | Website Design Work | Bellport Branding" />
      <meta property="twitter:description" content="Browse our portfolio of custom website designs for local businesses across Long Island, NY and beyond." />
      <meta property="twitter:image" content="https://www.bellportbranding.com/og-image.jpg" />

      <div className="min-h-screen bg-white">
        <Navbar />

        {/* Hero Section */}
        <section className="pt-36 pb-16 px-6 lg:px-8 text-center bg-white">
          <div className="max-w-4xl mx-auto">
            <p className="text-sm font-medium text-neutral-400 tracking-widest uppercase mb-5">Our Work</p>
            <h1 className="text-5xl sm:text-6xl lg:text-7xl font-semibold text-neutral-900 tracking-tight mb-6 leading-[1.05]">
              Websites that<br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-neutral-500 to-neutral-800">perform.</span>
            </h1>
            <p className="text-base sm:text-lg text-neutral-500 max-w-2xl mx-auto leading-relaxed mb-12 font-light">
              Every site we build is designed to look stunning and drive real results. Browse our portfolio of custom websites for Long Island businesses and beyond.
            </p>

            {/* Filter Bar */}
            <div className="flex flex-wrap justify-center gap-2">
              {filters.map((filter) => (
                <button
                  key={filter.value}
                  onClick={() => setActiveFilter(filter.value)}
                  className={`px-5 py-2 rounded-full text-sm font-medium transition-all duration-300 cursor-pointer whitespace-nowrap ${
                    activeFilter === filter.value
                      ? 'bg-neutral-900 text-white shadow-md'
                      : 'bg-neutral-100 text-neutral-600 hover:bg-neutral-200'
                  }`}
                >
                  {filter.label}
                </button>
              ))}
            </div>
          </div>
        </section>

        {/* Projects Grid */}
        <section className="pb-28 px-6 lg:px-8">
          <div className="max-w-6xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {filteredProjects.map((project) => (
                <div
                  key={project.id}
                  className="group bg-white rounded-2xl overflow-hidden border border-neutral-200 hover:shadow-xl hover:-translate-y-1 transition-all duration-500"
                >
                  <div className="w-full h-72 overflow-hidden bg-neutral-100">
                    <img
                      src={project.image}
                      alt={`${project.name} website design`}
                      title={`${project.name} website design by Bellport Branding`}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                    />
                  </div>
                  <div className="p-7">
                    <div className="flex items-start justify-between mb-3">
                      <div>
                        <p className="text-xs font-medium text-neutral-400 uppercase tracking-widest mb-1.5">
                          {project.category} · {project.location}
                        </p>
                        <h3 className="text-xl font-semibold text-neutral-900 tracking-tight">
                          {project.name}
                        </h3>
                      </div>
                      <a
                        href={project.url}
                        target="_blank"
                        rel="nofollow noopener noreferrer"
                        className="w-9 h-9 flex items-center justify-center rounded-full bg-neutral-100 group-hover:bg-neutral-900 transition-colors duration-300 shrink-0 ml-4 cursor-pointer"
                        aria-label={`Visit ${project.name} website`}
                      >
                        <i className="ri-arrow-right-up-line text-sm text-neutral-600 group-hover:text-white transition-colors duration-300"></i>
                      </a>
                    </div>
                    <p className="text-sm text-neutral-500 leading-relaxed mb-5">
                      {project.description}
                    </p>
                    <div className="flex flex-wrap gap-2 mb-5">
                      {project.tags.map((tag) => (
                        <span
                          key={tag}
                          className="px-3 py-1 bg-neutral-50 text-xs font-medium text-neutral-500 rounded-full border border-neutral-200"
                        >
                          {tag}
                        </span>
                      ))}
                    </div>
                    <a
                      href={project.url}
                      target="_blank"
                      rel="nofollow noopener noreferrer"
                      className="inline-flex items-center gap-2 text-sm font-medium text-neutral-900 hover:gap-3 transition-all duration-300 cursor-pointer whitespace-nowrap"
                    >
                      Visit Website
                      <i className="ri-arrow-right-line"></i>
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-24 px-6 lg:px-8 bg-neutral-100">
          <div className="max-w-3xl mx-auto text-center">
            <p className="text-sm font-medium text-neutral-400 uppercase tracking-widest mb-5">Ready to Get Started?</p>
            <h2 className="text-4xl sm:text-5xl font-semibold text-neutral-900 tracking-tight mb-6 leading-[1.1]">
              Ready to be our next<br />success story?
            </h2>
            <p className="text-base text-neutral-500 max-w-xl mx-auto leading-relaxed mb-10 font-light">
              Let&apos;s create a stunning website that drives real results for your business. Custom design, unlimited changes, and expert support — all for just $30/month.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="/"
                onClick={(e) => { e.preventDefault(); window.history.pushState({}, '', '/'); scrollToSection('start-project'); }}
                className="bg-neutral-900 text-white px-8 py-4 rounded-full text-sm font-medium hover:bg-neutral-800 transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                Start a Project
              </a>
              <a
                href="tel:+16316407888"
                className="flex items-center gap-2 text-neutral-700 hover:text-neutral-900 transition-colors cursor-pointer"
              >
                <span className="w-10 h-10 rounded-full bg-white flex items-center justify-center shadow-sm">
                  <i className="ri-phone-fill text-neutral-700 text-base"></i>
                </span>
                <span className="font-semibold text-base">(631) 640-7888</span>
              </a>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
}